module.exports = __webpack_public_path__ + "img/arrow.72aa1c26.svg";